import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // Initialize i18n
import App from './App';
import reportWebVitals from './reportWebVitals';

// Initialize Sentry if available
try {
  const Sentry = require('@sentry/react');
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
  
  // Get version from version.json - use environment variable at build time, fetch at runtime
  let appVersion = process.env.REACT_APP_VERSION || '3.2.0';
  let buildDate: string | null = process.env.REACT_APP_BUILD_DATE || null;
  
  // Try to fetch from /version.json at runtime (served from public folder)
  fetch('/version.json')
    .then(response => response.json())
    .then(versionInfo => {
      if (versionInfo?.platforms?.web) {
        appVersion = versionInfo.platforms.web;
        buildDate = versionInfo.buildDate || null;
        console.log('[Sentry] Loaded version from /version.json:', appVersion);
        // Update Sentry release if already initialized
        if (Sentry && Sentry.setTag) {
          Sentry.setTag('app_version', appVersion);
        }
      }
    })
    .catch(() => {
      // Use default version, non-critical
      if (appVersion === '3.2.0') {
        console.warn('[Sentry] Using default version:', appVersion);
      } else {
        console.log('[Sentry] Using version from environment variable:', appVersion);
      }
    });
  
  if (SENTRY_DSN && Sentry && Sentry.init) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.NODE_ENV || 'development',
      release: `allavail-web@${appVersion}`,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      beforeSend(event: any) {
        // Add version and device type information to all events
        event.tags = {
          ...event.tags,
          app_version: appVersion,
          device_type: 'web',
        };
        if (buildDate) {
          event.tags.build_date = buildDate;
        }
        return event;
      },
    });
  }
} catch (e) {
  // Sentry not installed, continue without it
  console.log('Sentry not available, error tracking disabled');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
